'use strict';

function parseBirthday(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return null;
    }

    var parts = value.split('-');
    var year = Number(parts[0]);
    var month = Number(parts[1]);
    var day = Number(parts[2]);
    if (year < 1 || month < 1 || month > 12 || day < 1 || day > 31) {
        return null;
    }

    var birthday = new Date(0);
    birthday.setUTCFullYear(year, month - 1, day);
    if (birthday.getUTCFullYear() !== year || birthday.getUTCMonth() !== month - 1 || birthday.getUTCDate() !== day) {
        return null;
    }

    return birthday;
}

function isBirthdayValid(value, options, today) {
    var birthday = parseBirthday(value);
    if (!birthday) {
        return false;
    }

    var settings = options || {};
    var currentDate = today || new Date();
    var latestBirthday = new Date(0);
    latestBirthday.setUTCFullYear(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

    if (birthday > latestBirthday) {
        return false;
    }
    if (settings.isBirthdayYearCheckEnabled && birthday.getUTCFullYear() <= 1900) {
        return false;
    }
    if (settings.isBirthdayAgeCheckEnabled) {
        var age = currentDate.getFullYear() - birthday.getUTCFullYear();
        if (currentDate.getMonth() < birthday.getUTCMonth()
            || (currentDate.getMonth() === birthday.getUTCMonth() && currentDate.getDate() < birthday.getUTCDate())) {
            age -= 1;
        }
        if (age < 18) {
            return false;
        }
    }

    return true;
}

module.exports = {
    parseBirthday: parseBirthday,
    isBirthdayValid: isBirthdayValid
};